import { useTracking } from "./js/tracking"
import { useHighlights } from "./js/highlights"
import { useWebhookForms } from "./js/webhook-forms"
import { useInfiniteScroll } from "./js/infinite-scroll"

useTracking(document)
useHighlights(document)
useWebhookForms(document)
useInfiniteScroll(document)
